import { createSelector } from "@reduxjs/toolkit";

import { FilterName } from "src/modules/filter/shared/enums/filter-name";
import { getFilter } from "src/modules/filter/store/filters.selector";

import { IFarmsDto } from "..";
import { farmsApi } from "../../store/farms.rtkq";

const selectFarmsResult = farmsApi.endpoints.fetchFarms.select(undefined);

const EMPTY_FARMS: IFarmsDto[] = [];

export const selectCurrentFarm = createSelector(
  [(state) => selectFarmsResult(state).data ?? EMPTY_FARMS, getFilter(FilterName.FarmId)],
  (farms, farmId) => {
    if (!farmId) return null;
    return farms.find((farm) => farm.id === farmId) || null;
  }
);
